// extracted by mini-css-extract-plugin
export default {"userFormWidget":"UserFormWidget_userFormWidget__ThebE","buttonts":"UserFormWidget_buttonts__MGihn"};